import {css} from 'lit';
import {tablet} from '../../js/services/const';

export default css`
  /* the new slider */

  .zodiacSliderOuter {
    padding: 0 var(--article-padding);
  }

  .zodiacSliderOuter.tool {
    padding: 0;
  }

  .zodiacSlider {
    display: flex;
    background: var(--horoscope-bg) no-repeat 50% 50%;
    background-size: cover;
  }

  .zodiacSlider:before {
    display: none;
  }

  .zodiacSlider .left,
  .zodiacSlider .right {
    position: relative;
    width: 2.4rem;
    cursor: pointer;
  }

  .zodiacSlider .left:before,
  .zodiacSlider .right:before {
    position: absolute;
    font-size: 1.8rem;
    line-height: 1.8rem;
    top: 50%;
    margin-top: -0.9rem;
    left: 50%;
    margin-left: -0.9rem;
    color: #fff;
    display: inline-block;
  }

  .zodiacSlider .left:hover,
  .zodiacSlider .right:hover {
    background-color: rgba(0, 0, 0, 0.25);
  }

  .zodiacSlider .right.disabled:before,
  .zodiacSlider .left.disabled:before {
    display: none;
  }

  .zodiacSlider .right.disabled:hover,
  .zodiacSlider .left.disabled:hover {
    background-color: transparent;
  }

  @media (min-width: ${tablet}px) {
    .zodiacSliderOuter {
      padding: 0;
    }
  }
`;
